import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsAddressCompleteGuard } from '@gk/gk-modules';
import { CompositeGuard } from '../../../guards/composite/composite.guard';
import { MainRoutes } from '../../../guards/guard.models';
import { PlanningActCurrentStateGuard } from '../../../guards/planning-act-current-state/planning-act-current-state.guard';
import { RequestInProgressGuard } from '../../../guards/request-in-progress/request-in-progress.guard';
import { SessionGuard } from '../../../guards/session/session.guard';
import { WebPortalResolver } from '../../../resolvers/web-portal/web-portal.resolver';
import { MainRequestsListComponent } from '../../../shared/main-requests-list/main-requests-list.component';
import { PARNewRequestComponent } from './new-request/new-request.component';
import { PlanningActRequestComponent } from './planning-act-request.component';

const planningActRequestRoutes: Routes = [
  {
    path: MainRoutes.PlanningActCommentsRequest,
    component: PlanningActRequestComponent,
    canActivate: [CompositeGuard],
    data: {
      guards: [SessionGuard, IsAddressCompleteGuard],
    },
    resolve: {
      [WebPortalResolver.field]: WebPortalResolver,
    },
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: PARNewRequestComponent,
        canActivate: [PlanningActCurrentStateGuard],
        canDeactivate: [RequestInProgressGuard],
        data: {
          noOwnerMessageTranslationKey:
            'PLANNING_ACT_REQUEST.COMMENTS_REQUEST_NO_ACCESS_MESSAGE', // TODO: Replace with actual translation key
        },
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: MainRoutes.PlanningActCreationAmendmentRequest,
    component: PlanningActRequestComponent,
    canActivate: [SessionGuard],
    resolve: {
      [WebPortalResolver.field]: WebPortalResolver,
    },
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: PARNewRequestComponent,
        canActivate: [PlanningActCurrentStateGuard],
        canDeactivate: [RequestInProgressGuard],
        data: {
          noOwnerMessageTranslationKey:
            'PLANNING_ACT_REQUEST.CREATION_AMENDMENT_REQUEST_NO_ACCESS_MESSAGE', // TODO: Replace with actual translation key
        },
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: MainRoutes.PlanningActProjectRequest,
    component: PlanningActRequestComponent,
    canActivate: [SessionGuard],
    resolve: {
      [WebPortalResolver.field]: WebPortalResolver,
    },
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: PARNewRequestComponent,
        canActivate: [PlanningActCurrentStateGuard],
        canDeactivate: [RequestInProgressGuard],
        data: {
          noOwnerMessageTranslationKey:
            'PLANNING_ACT_REQUEST.PROJECT_REQUEST_NO_ACCESS_MESSAGE', // TODO: Replace with actual translation key
        },
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(planningActRequestRoutes)],
  providers: [
    CompositeGuard,
    SessionGuard,
    RequestInProgressGuard,
    IsAddressCompleteGuard,
  ],
  exports: [RouterModule],
})
export class PlanningActRequestRoutingModule {}
